import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: '张总',
      company: 'XX建筑公司',
      content: '识道造价团队专业高效，服务态度非常好，项目完成质量超出预期。',
      rating: 5
    },
    {
      name: '李经理',
      company: 'XX工程公司',
      content: '数智平台非常实用，大大提升了我们的工作效率，强烈推荐！',
      rating: 5
    },
    {
      name: '王总',
      company: 'XX开发公司',
      content: '合作多年，识道造价一直是我们最信赖的合作伙伴。',
      rating: 5
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <h2 className="section-title">客户评价</h2>
        <p className="section-subtitle">客户信赖，口碑见证</p>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card card">
              <div className="testimonial-rating">
                {'★'.repeat(testimonial.rating)}
              </div>
              <p className="testimonial-content">"{testimonial.content}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.company}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;



